import axios from 'axios';
import positionsService from '../services/position.service';
import eventsService from '../services/events.service';
import cssService from '../services/css.service';
import scrollLimitedService from '../services/scroll-limited.service';

/*
 * Elements
 */
const contentEl = document.querySelector('.page-dashboard');
const footerEl = document.querySelector('.container-footer-dashboard');

/* Footer: Only for dashboard */
if (footerEl) {

  const colSm3 = document.querySelector('.col-sm-3');
  const headerEl = document.querySelector('.header-placeholder');

  const profileSidebar = document.querySelector('.dashboard-left-sidebar-scrolled');
  const adSidebar = document.querySelector('.dashboard-public-banner');

  const leftScrollLim = scrollLimitedService.create(profileSidebar);
  const rightScrollLim = scrollLimitedService.create(adSidebar);

  /**
   * On resize
   */
  const onResize = (event) => {
    const limitTop = headerEl.offsetHeight;
    const limitBottom = window.innerHeight - footerEl.offsetHeight;
    leftScrollLim.setLimits(limitTop, limitBottom);
    rightScrollLim.setLimits(limitTop, limitBottom);
    if (window.innerWidth >= cssService.bootstrapBreakpoints.sm) {
      leftScrollLim.start();
      rightScrollLim.start();
    } else {
      leftScrollLim.stop();
      rightScrollLim.stop();
    }
  }
  window.addEventListener('resize', onResize);
  for (let i = 0; i <= 5; i++) {
    setTimeout(onResize, 200 * i); // just in case
  }

}

/* Dashboard content: play count */
if (contentEl)
{
  /* play count increment url */
  const playCountIncrementUrl = contentEl.dataset.ajaxPlayCountIncrementUrl;

  /* The elements to play */
  const videoEls = document.querySelectorAll('video');

  /* Remember if alredy fired that id */
  let firedPlayCountAudioIds = [];

  /* Set events for video */
  for (const videoEl of videoEls) {
    videoEl.addEventListener('play', (event) => {
      const audioId = event.target.dataset.audioId;
      playCountIncrement(audioId);
    });
  }

  /* Set events for audio */
  eventsService.addListener(eventsService.AUDIO_PLAYER_START, (event) => {
    const audioWrapperEl = event.target.parentElement;
    if (audioWrapperEl.dataset.audioId) {
      playCountIncrement(audioWrapperEl.dataset.audioId);
    }
  });

  /* Function to increment play count */
  const playCountIncrement = (audioId) => {
    if (audioId && undefined === firedPlayCountAudioIds
        .find(audioIdIt => audioIdIt == audioId))
    {
      firedPlayCountAudioIds.push(audioId);
      axios.post(playCountIncrementUrl, {
          audio_id: audioId,
        })
        .then((response) => {})
        .catch((error) => {});
      }
  }

  /* Declare global function */
  window.dashboardPlayCountIncrement = playCountIncrement;

}
